import { HrHorizontal } from "../Global/HrHorizontal";
import { HrVertical } from "../Global/HrVertical";
import { PrioritiesIncidents } from "../Widgets/PrioritiesIncidents";
import { TextWidget } from "../Widgets/TextWidget";
import useFetchData from "../../utils/hooks/useFetchData";
import Spinner from "../Global/Spinner";
import { SimpleBarWidget } from "../Widgets/SimpleBarWidget";
import { Card } from "antd";
import { CostumPieChart2 } from "../Global/CostumPieChart2";

export const Parking = () => {
  const { data: parkingData } = useFetchData("/nova_wallboards/getparkingdata");
  
  if (parkingData) {
    return (
      <>
        <div style={{ width: '33.3%', textAlign: 'center' }}>
          <Card.Grid style={{ width: '100%', textAlign: 'center', height: '39%', padding: '5px' }}>
            <PrioritiesIncidents data={{
              red: parkingData?.incidents.red,
              orange: parkingData?.incidents.orange,
              yellow: parkingData?.incidents.yellow,
            }} />
          </Card.Grid>

          <HrHorizontal marginBottom={0} />

          <Card.Grid style={{ width: '100%', height: '56%', padding: '5px' }}>
            <div style={{ width: 'inherit', display: 'flex', justifyContent: 'center', flexFlow: 'wrap' }}>
              <CostumPieChart2 data={parkingData.averageOcuption[0]} name={'P. Total'} colors={["#484848", '#a1a1a1']} style={{ flex: 1 }} />
              <CostumPieChart2 data={parkingData.averageOcuption[1]} name={'P. Externo'} colors={["#006465", '#006465b3']} style={{ flex: 1 }} />
              <CostumPieChart2 data={parkingData.averageOcuption[2]} name={'P. Interior -1'} colors={["#88c425", '#88c4258c']} style={{ flex: 2 }} />
              <CostumPieChart2 data={parkingData.averageOcuption[3]} name={'P. Interior -2'} colors={["#eb7c30", '#eb7c3087']} style={{ flex: 2 }} />
            </div>
            <p style={{ fontWeight: "bold", color: "#659767", margin: "0px", fontSize: "small" }}>
              OCUPAÇÃO ATUAL POR PARQUE
            </p>
          </Card.Grid>
        </div>

        <HrVertical />

        <div style={{ width: '33.3%', textAlign: 'center' }}>
          <Card.Grid style={{ width: '100%', display: 'flex', justifyContent: 'center', height: '20%', padding: '5px' }}>
            <TextWidget
              number={parkingData.numberOfEntriesInThePark}
              unitMesure="/dia"
              label="NÚMERO ATUAL DE ENTRADAS"
            />
          </Card.Grid>
          <HrHorizontal />
          <Card.Grid style={{ width: '100%', display: 'flex', justifyContent: 'center', height: '20%', padding: '5px' }}>
            <TextWidget
              number={parkingData.numberOfUsesOfThePark}
              unitMesure="/semana atual"
              label="NÚMERO ACUMULADO DE ENTRADAS"
            />
          </Card.Grid>
          <HrHorizontal />
          <Card.Grid style={{ width: '100%', display: 'flex', justifyContent: 'center', height: '50%', padding: '5px' }}>
            <SimpleBarWidget
              data={parkingData.occupationByWeekDay}
              layout='vertical'
              label="NÚMERO DE ENTRADAS NO CAMPUS"
              height="100%"
              name="Entradas" />
          </Card.Grid>
        </div>
        <HrVertical />
        <div style={{ width: '33.3%', textAlign: 'center' }}>
          <Card.Grid style={{ width: '100%', display: 'flex', justifyContent: 'center', height: '20%', padding: '5px' }}>
            <TextWidget
              number={parkingData.numberOfExitsOfThePark}
              unitMesure="/dia"
              label="NÚMERO ATUAL DE SAÍDAS" />
          </Card.Grid>
          <HrHorizontal />
          <Card.Grid style={{ width: '100%', display: 'flex', justifyContent: 'center', height: '75%', padding: '5px' }}>
            <SimpleBarWidget
              data={parkingData.occupationByCategoryInWeek}
              layout='vertical'
              label="NÚMERO SEMANAL ACUMULADO DE ENTRADAS POR PARQUE"
              height="100%" 
              name="Entradas" />
          </Card.Grid>
        </div>
      </>
    );
  } else {
    return (
      <div style={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <Spinner />
      </div>
    );
  }
};